/* Min order guard – léger + buy-now block + CTA "Continuer mes achats"
   - Bloque checkout & "Acheter maintenant" si total < 10.00 CHF
   - Bandeau au-dessus des boutons + lien vers l'accueil
   - Toast mobile non bloquant
*/
(function () {
  // === PARAMS =========================================================
  const MINIMUM_AMOUNT = 10;   // CHF
  const CURRENCY = 'CHF';
  const HOMEPAGE_URL = '/';
  const CTA_LABEL = 'Continuer mes achats';
  const MIN_CENTS = Math.round(MINIMUM_AMOUNT * 100);

  // Boutons/containers menant au checkout (panier, drawer, produit…)
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'button.cart-recap__checkout',
    'button.cart__submit',
    'button.cart__checkout',
    'a[href*="/checkout"]',
    '.shopify-payment-button__button',
    '.shopify-payment-button__button--unbranded',
    '.shopify-payment-button'
  ].join(', ');

  // ---------- Utils ----------
  function formatMoney(cents) { return (cents / 100).toFixed(2) + ' ' + CURRENCY; }

  // ✨ Nouveau message (proposition n°1)
  function buildMinOrderText(totalCents) {
    const missing = Math.max(MIN_CENTS - totalCents, 0);
    const min = formatMoney(MIN_CENTS);
    const miss = formatMoney(missing);
    return `Presque terminé 🎉 Le minimum de commande est de ${min}. Il ne manque que ${miss} — ajoutez un petit extra pour vos enfants et validez votre panier.`;
  }

  async function fetchCartTotalCents() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    return cart.total_price; // centimes
  }

  // --- Mobile toast (non bloquant) ---
  const MOBILE_MAX = 768;
  function isSmallScreen() { return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches; }
  function showToast(msg) {
    let el = document.getElementById('min-order-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'min-order-toast';
      el.style.cssText =
        'pointer-events:none; position:fixed; left:50%; transform:translateX(-50%); ' +
        'bottom: calc(env(safe-area-inset-bottom, 0px) + 12px); z-index: 9999; ' +
        'background: rgba(17,17,17,.92); color:#fff; padding:10px 12px; border-radius:12px; ' +
        'font-size:13px; line-height:1.35; text-align:center; max-width:88vw; ' +
        'box-shadow:0 6px 24px rgba(0,0,0,.18); opacity:0; transition:opacity .18s ease;';
      document.body.appendChild(el);
      const hideOnScroll = () => hideToast();
      window.addEventListener('scroll', hideOnScroll, { passive: true });
      window.addEventListener('touchstart', hideOnScroll, { passive: true });
    }
    el.textContent = msg;
    el.style.display = 'block';
    requestAnimationFrame(() => { el.style.opacity = '1'; });
    clearTimeout(window.__minToastTimer);
    window.__minToastTimer = setTimeout(() => hideToast(), 2200);

    function hideToast() {
      if (!el) return;
      el.style.opacity = '0';
      setTimeout(() => { if (el) el.style.display = 'none'; }, 180);
    }
  }

  // --- Bandeau + CTA au-dessus des boutons "Payer" -------------------
  function ensureInlineBanner(aroundBtn) {
    let holder = document.getElementById('min-order-inline');
    if (holder) return holder;

    const wrapper =
      (aroundBtn && (aroundBtn.closest('.cart-recap, .cart-recap__buttons, .cart-drawer__footer, .cart__footer, form') || aroundBtn.parentElement))
      || document.querySelector('.cart-recap, .cart-recap__buttons, .cart-drawer__footer, .cart__footer, form');

    if (!wrapper) return null;

    holder = document.createElement('div');
    holder.id = 'min-order-inline';
    holder.setAttribute('role', 'status');
    holder.style.cssText =
      'margin:10px 0 12px;padding:10px 12px;border-radius:8px;' +
      'background:#fff3cd;border:1px solid #ffe69c;color:#664d03;' +
      'font-size:14px;line-height:1.35;text-align:center;';
    wrapper.insertBefore(holder, wrapper.firstChild);

    // CTA vers l'accueil
    const cta = document.createElement('a');
    cta.href = HOMEPAGE_URL;
    cta.textContent = CTA_LABEL;
    cta.style.cssText =
      'display:inline-block;margin-top:8px;padding:8px 12px;border-radius:8px;background:#fff;' +
      'border:1px solid #ffe08a;color:#664d03;text-decoration:none;font-weight:600;';
    cta.id = 'min-order-cta-home';
    holder.appendChild(document.createElement('div')).appendChild(cta);

    return holder;
  }
  function showInlineBanner(message, aroundBtn) {
    const el = ensureInlineBanner(aroundBtn);
    if (!el) return;
    if (!el.firstChild || el.firstChild.nodeType !== 3) {
      el.insertBefore(document.createTextNode(message), el.firstChild);
    } else {
      el.firstChild.nodeValue = message;
    }
    el.style.display = '';
  }
  function hideInlineBanner() {
    const el = document.getElementById('min-order-inline');
    if (el) el.style.display = 'none';
  }

  // --- Bloquer "Acheter maintenant" proprement -----------------------
  function setBuyNowBlocked(blocked) {
    let style = document.getElementById('min-buy-now-blocker');
    if (!style) {
      style = document.createElement('style');
      style.id = 'min-buy-now-blocker';
      document.head.appendChild(style);
    }
    style.textContent = blocked ? `
      .shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__button--unbranded {
        pointer-events: none !important; opacity: .55 !important; filter: grayscale(1);
      }
    ` : '';
  }
  async function refreshMinState() {
    try {
      const total = await fetchCartTotalCents();
      setBuyNowBlocked(total < MIN_CENTS);
    } catch (e) {
      console.warn('min-order: refresh state error', e);
    }
  }

  // --- Ne jamais bloquer “Ajouter au panier” -------------------------
  function isAddToCart(el) {
    if (!el) return false;
    const form = el.closest && el.closest('form');
    if (form && /\/cart\/add(\.js)?/i.test(form.action || '')) return true;
    const txt = (el.textContent || el.value || '').toLowerCase();
    if (/(ajouter|ajoutez).*(panier)|add to cart|in den warenkorb|aggiungi al carrello/.test(txt)) return true;
    return !!el.closest('[name="add"], [data-add-to-cart], .add-to-cart, .product-form__submit, .product__add-to-cart');
  }

  // ---------- Gate principal (léger) ---------------------------------
  let busy = false;
  async function gateCheckout(e, clickedEl) {
    if (busy) { e && e.preventDefault(); return; }
    busy = true;
    try {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      const total = await fetchCartTotalCents();

      if (total < MIN_CENTS) {
        const msg = buildMinOrderText(total);
        showInlineBanner(msg, clickedEl);
        setBuyNowBlocked(true);
        if (isSmallScreen()) showToast(msg); else window.alert(msg);
        return false;
      }

      hideInlineBanner();
      setBuyNowBlocked(false);
      window.location.assign('/checkout');
      return true;
    } catch (err) {
      console.warn('min-order error:', err);
      window.location.assign('/checkout');
      return true;
    } finally {
      setTimeout(() => (busy = false), 120);
    }
  }

  // ---------- Bindings minimalistes ----------------------------------
  ['click', 'touchstart'].forEach(evt => {
    document.addEventListener(evt, (e) => {
      const t = e.target;
      if (isAddToCart(t)) return;
      const btn = t.closest && t.closest(CHECKOUT_SELECTOR);
      if (!btn) return;
      if (btn.closest && btn.closest('[data-skip-minimum="true"]')) return;
      gateCheckout(e, btn);
    }, true);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (/\/cart\/add(\.js)?/i.test(form.action || '')) return;
    if (form.querySelector(CHECKOUT_SELECTOR) || (form.action && form.action.includes('/checkout'))) {
      if (form.hasAttribute('data-skip-minimum')) return;
      gateCheckout(e, form.querySelector(CHECKOUT_SELECTOR));
    }
  }, true);

  document.addEventListener('DOMContentLoaded', refreshMinState);
  window.addEventListener('pageshow', refreshMinState, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshMinState(); }, true);
})();
